<script>
  export let question;
  export let updateWorkingQuestion;

  let nodeTypes;

  function getNodeTypeValues() {
    const nodesHandler = question.dataset?.find(handler => handler[0] === 'nodes');
    const setSelfHandler = question.dataset?.find(handler => handler[0] === 'setSelf');
    const selfPropsHandler = question.dataset?.find(handler => handler[0] === 'selfProps');
    
    if (nodesHandler && nodesHandler[1] && nodesHandler[1].type) {
      return Array.isArray(nodesHandler[1].type) ? nodesHandler[1].type : [nodesHandler[1].type];
    }
    
    if (selfPropsHandler && selfPropsHandler[1] && selfPropsHandler[1].type) {
      return Array.isArray(selfPropsHandler[1].type) ? selfPropsHandler[1].type : [selfPropsHandler[1].type];
    }
    
    return ['node-type'];
  }
  
  function updateNodeTypeValue(index, value) {
    const dataset = [...question.dataset];
    const nodesHandlerIndex = dataset.findIndex(handler => handler[0] === 'nodes');
    const selfPropsHandlerIndex = dataset.findIndex(handler => handler[0] === 'selfProps');
    
    if (nodesHandlerIndex !== -1) {
      const handler = [...dataset[nodesHandlerIndex]];
      const props = { ...handler[1] };
      const types = Array.isArray(props.type) ? [...props.type] : [props.type];
      types[index] = value;
      props.type = types.length === 1 ? types[0] : types;
      handler[1] = props;
      dataset[nodesHandlerIndex] = handler;
    } else if (selfPropsHandlerIndex !== -1) {
      const handler = [...dataset[selfPropsHandlerIndex]];
      const props = { ...handler[1] };
      const types = Array.isArray(props.type) ? [...props.type] : [props.type];
      types[index] = value;
      props.type = types.length === 1 ? types[0] : types;
      handler[1] = props;
      dataset[selfPropsHandlerIndex] = handler;
    }
    
    updateWorkingQuestion('dataset', dataset);
  }
  
  function removeNodeTypeValue(index) {
    const dataset = [...question.dataset];
    const nodesHandlerIndex = dataset.findIndex(handler => handler[0] === 'nodes');
    const selfPropsHandlerIndex = dataset.findIndex(handler => handler[0] === 'selfProps');
    
    if (nodesHandlerIndex !== -1) {
      const handler = [...dataset[nodesHandlerIndex]];
      const props = { ...handler[1] };
      let types = Array.isArray(props.type) ? [...props.type] : [props.type];
      types.splice(index, 1);
      if (types.length === 0) types = ['node-type'];
      props.type = types.length === 1 ? types[0] : types;
      handler[1] = props;
      dataset[nodesHandlerIndex] = handler;
    } else if (selfPropsHandlerIndex !== -1) {
      const handler = [...dataset[selfPropsHandlerIndex]];
      const props = { ...handler[1] };
      let types = Array.isArray(props.type) ? [...props.type] : [props.type];
      types.splice(index, 1);
      if (types.length === 0) types = ['organization'];
      props.type = types.length === 1 ? types[0] : types;
      handler[1] = props;
      dataset[selfPropsHandlerIndex] = handler;
    }
    
    updateWorkingQuestion('dataset', dataset);
  }
  
  function addNodeTypeValue() {
    const dataset = [...question.dataset];
    const nodesHandlerIndex = dataset.findIndex(handler => handler[0] === 'nodes');
    const selfPropsHandlerIndex = dataset.findIndex(handler => handler[0] === 'selfProps');
    
    if (nodesHandlerIndex !== -1) {
      const handler = [...dataset[nodesHandlerIndex]];
      const props = { ...handler[1] };
      const types = Array.isArray(props.type) ? [...props.type] : [props.type];
      types.push('new-type');
      props.type = types;
      handler[1] = props;
      dataset[nodesHandlerIndex] = handler;
    } else if (selfPropsHandlerIndex !== -1) {
      const handler = [...dataset[selfPropsHandlerIndex]];
      const props = { ...handler[1] };
      const types = Array.isArray(props.type) ? [...props.type] : [props.type];
      types.push('new-type');
      props.type = types;
      handler[1] = props;
      dataset[selfPropsHandlerIndex] = handler;
    }
    
    updateWorkingQuestion('dataset', dataset);
  }
  
  // Reactive derived state - automatically updates when question changes
  $: question, nodeTypes = getNodeTypeValues();
</script>

<div class="field-wrapper">
  <label>
    Node Type Values
    <span class="type-count-badge">{nodeTypes.length} type{nodeTypes.length !== 1 ? 's' : ''}</span>
  </label>
  <div class="type-values-editor">
    
    {#each nodeTypes as typeValue, idx}
      <div class="type-item">
        <div class="type-input">
          <input 
            type="text"
            value={typeValue}
            on:input={(e) => updateNodeTypeValue(idx, e.target.value)}
            placeholder="e.g., person, organisation, project"
            class="type-field"
          />
        </div>
        <div class="type-actions">
          {#if nodeTypes.length > 1}
            <button 
              class="btn btn-small btn-danger"
              on:click={() => removeNodeTypeValue(idx)}
              title="Remove type"
            >
              ×
            </button>
          {/if}
        </div>
      </div>
    {/each}
    
    <div class="type-footer">
      <button class="btn btn-secondary" on:click={addNodeTypeValue}>
        Add Type Value
      </button>
    </div>
  </div>
</div>

<style lang="scss">
  .field-wrapper {
    margin-bottom: 20px;
    
    > label {
      display: flex;
      align-items: center;
      gap: 8px;
      font-weight: bold;
      margin-bottom: 8px;
      font-size: 0.8rem;
      color: #374151;
    }
  }
  
  .type-count-badge {
    background: #3b82f6;
    color: white;
    padding: 2px 6px;
    border-radius: 10px;
    font-size: 9px;
    font-weight: bold;
    letter-spacing: 0.5px;
  }
  
  .type-values-editor {
    border: 2px solid #e5e7eb;
    border-radius: 6px;
    padding: 10px;
    background: rgba(255, 255, 255, 0.8);
  }
  
  .type-item {
    display: flex;
    gap: 8px;
    align-items: center;
    margin-bottom: 8px;
    padding: 8px;
    border-radius: 4px;
    transition: all 0.2s ease;
    
    &:hover {
      background: rgba(59, 130, 246, 0.05);
    }
    
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  .type-input {
    flex: 1;
    
    .type-field {
      width: 100%;
      padding: 6px 10px;
      border: 1px solid #d1d5db;
      border-radius: 4px;
      background: #fff;
      font-size: 0.75rem;
      font-weight: 500;
      
      &:focus {
        outline: none;
        border-color: #3b82f6;
        box-shadow: 0 0 0 1px #3b82f6;
      }
      
      &::placeholder {
        color: #9ca3af;
        font-weight: normal;
      }
    }
  }
  
  .type-actions {
    display: flex;
    align-items: center;
    flex: 0 0 auto;
  }
  
  .type-footer {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #e5e7eb;
    text-align: center;
  }
  
  .btn {
    padding: 4px 8px;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    font-size: 11px;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    transition: all 0.2s ease;
    
    &.btn-secondary {
      background: #10b981;
      color: white;
      
      &:hover {
        background: #059669;
      }
    }
    
    &.btn-danger {
      background: #ef4444;
      color: white;
      
      &:hover {
        background: #dc2626;
      }
    }
    
    &.btn-small {
      padding: 4px 6px;
      font-size: 10px;
    }
  }
</style>